import getSubtotalCartSelector from 'modules/cart/redux/selectors/get-subtotal'

/**
 * @param props
 * @param props.hasUnlockedSecondTierCartTracker
 * @param props.state
 * @param props.isGiftUrl
 * @param props.hasGiftCard
 * @param props.giftAmount
 * @return {*}
 */
const getSubtotalCartDiscountTrackerDeliverySelectUtil = (props) => {
  const {
    hasUnlockedSecondTierCartTracker,
    state,
    isGiftUrl,
    hasGiftCard,
    giftAmount
  } = props

  const debugProps = {
    hasUnlockedSecondTierCartTracker
  }

  // feat(AS-1511): Enable free shipping for orders over $35 after discount
  let ignoreDiscounts = true
  if (
    !hasUnlockedSecondTierCartTracker
  ) {
    ignoreDiscounts = false
  }

  debugProps.ignoreDiscounts = ignoreDiscounts
  // logUtil('getSubtotalCartDiscountTrackerDeliverySelectUtil').debug('debugProps=', debugProps)

  let extraSubtotal
  if (
    isGiftUrl &&
    !hasGiftCard &&
    giftAmount
  ) {
    // logUtil('getSubtotalCartDiscountTrackerDeliverySelectUtil').debug('manually add gift amount')
    extraSubtotal = giftAmount
  }

  return getSubtotalCartSelector({
    ignoreDiscounts,
    extraSubtotal
  })(state)
}

export default getSubtotalCartDiscountTrackerDeliverySelectUtil
